import smartwizard from "smartwizard";
import $ from "jquery";
import {getGeometryByLayerName, getLayerByName, updateMapSize} from "@/helpers/ol-layer-helper";
import {getDefaultName} from "@/helpers/geo-json-helper";
import {showNotification} from "@/helpers/toastr-helper";
import {loadDateValues} from "@/helpers/date-picker-helper";
import {getFileUploads} from "@/helpers/file-upload-helper";
import {WKT} from "ol/format";
import {Point} from "ol/geom";
import {load} from "recaptcha-v3";
import {postWfst} from "@/http/services/http-services-wfst";
import {processWfstRequest} from "@/helpers/wfst-helper";
import * as Ladda from 'ladda';
import {transformExtent} from "ol/proj";
import {viewFit} from "@/helpers/ol-view";
import {checkValidFields} from "@/helpers/valid-helper";

export function initSmartWizard() {
    smartwizard($('#smartwizard'))
    window.smartWizard = $('#smartwizard').smartWizard({
        theme: 'arrows',
        autoAdjustHeight: false,
        transition: {
            animation: '', // Animation effect on navigation, none|fade|slideHorizontal|slideVertical|slideSwing|css(Animation CSS class also need to specify)
            speed: '400', // Animation speed. Not used if animation is 'css'
            easing: '', // Animation easing. Not supported without a jQuery easing plugin. Not used if animation is 'css'
            prefixCss: '', // Only used if animation is 'css'. Animation CSS prefix
            fwdShowCss: '', // Only used if animation is 'css'. Step show Animation CSS on forward direction
            fwdHideCss: '', // Only used if animation is 'css'. Step hide Animation CSS on forward direction
            bckShowCss: '', // Only used if animation is 'css'. Step show Animation CSS on backward direction
            bckHideCss: '', // Only used if animation is 'css'. Step hide Animation CSS on backward direction
        },
        style: {
            // btnPrevCss: 'btn-primary',
            // btnNextCss: 'sw-btn-next btn-primary'
            // btnPrevCss: 'btn sw-btn-next sw-btn btn-primary',
            // btnNextCss: 'btn sw-btn-next sw-btn btn-primary'
        },
        toolbar: {
            position: 'bottom', // none|top|bottom|both
            showNextButton: true, // show/hide a Next button
            showPreviousButton: true, // show/hide a Previous button
            extraHtml: `<button id="btnSubmitNewNotification" class="btn sw-btn sw-btn-finish text-transform-none btn-primary ladda-button" style="display: none">Melding versturen</button>` // Extra html to show on toolbar
        },
        backButtonSupport: false,
        enableUrlHash: false,
        true: true,
        lang: { // Language variables for button
            next: 'Volgende',
            previous: 'Vorige'
        }
    });

    window.smartWizard.on("leaveStep", function(e, anchorObject, currentStepIndex, nextStepIndex, stepDirection) {
        loadDateValues()

        if(stepDirection === 'forward') {
            const isValid = checkValidFields(currentStepIndex)
            if(!isValid) {
                return false
            }
        }

        document.querySelector('.tab-content').scrollTo({
            top: 0,
            left: 0
        });

        setStepName(nextStepIndex)
    });

    window.smartWizard.on("showStep", function (e, anchorObject, stepIndex) {
        if((window.wizard.Items.length - 1) === stepIndex) {
            $('.sw-btn-next').hide()
            $('.sw-btn-finish').show()
        } else {
            $('.sw-btn-next').show()
            $('.sw-btn-finish').hide()
        }

        updateMapSize()

        let extent = null

        if(window.wizard.Layer.Layer !== null && window.wizard.Layer.bbox !== '') {
            extent = window.wizard.Layer.bbox
        }
        if(window.wizard.LinkedLayer.Layer !== null && window.wizard.LinkedLayer.bbox !== '') {
            extent = window.wizard.LinkedLayer.bbox
        }

        if(extent !== null && extent !== '') {
            extent = extent.split(',')
            extent.map((extendItem, key) => {
                extent[key] = parseFloat(extendItem)
            })
        }

        if(extent !== null) {
            extent = new transformExtent(extent, "EPSG:28992", "EPSG:3857");
        } else {
            extent = new transformExtent(window.wizard.settings.Extent, "EPSG:28992", "EPSG:3857")
        }

        viewFit(extent)
    })

    window.smartWizard.on("loaded", function(e) {

        const stepIndex = window.smartWizard.smartWizard("getStepInfo").currentStep

        setStepName(stepIndex)
    });

    initSmartWizardListener()
}

export function setStepName(index) {
    const name = window.wizard.Items[index].Name

    document.getElementById('divPageName').innerHTML = name
}

export function resetSmartWizard() {
    window.smartWizard.smartWizard("reset");

    updateMapSize()

    initSmartWizardListener()
}

export function getWizardItems() {
    const wizardItems = []
    window.wizard.Items.map( (wizardItem) => {
        wizardItem.Items.map( wizardChildItem => {
            wizardItems.push(wizardChildItem)
        })
    })
    return wizardItems
}

export function getWizardItemByAttributeID(attributeID) {
    let wizardItem
    window.wizard.Items.map( item => {
        item.Items.map(childItem => {
            if(parseInt(childItem.AttributeID) === parseInt(attributeID)) {
                wizardItem = childItem
            }
        })
    })

    return wizardItem
}

function initSmartWizardListener() {
    document.querySelector('#btnSubmitNewNotification').addEventListener('click',  (element) => {

        const checkValid = checkValidFields(window.wizard.Items.length - 1)
        if(!checkValid) {
            return false
        }


        var l = Ladda.create(element.target);
        l.start();

        const request = {}
        request.data = []
        request.action = "create"

        const dataItem = {}
        document.querySelectorAll('form-element').forEach(formElement => {

            if(formElement.dataset.attributeTypeId !== 'null') {

                let name =  formElement.dataset.id
                let value = ''
                let attributeName = ''
                let activeElement = undefined

                switch (parseInt(formElement.dataset.attributeTypeId)) {
                    case 12: // Input select
                        activeElement = formElement.querySelector('.active')
                        if(activeElement) {
                            value = activeElement.closest('form-domain-list-item').dataset.value
                        }
                        break;
                    case 13: // Input checkbox
                        activeElement = formElement.querySelector('.active')
                        if(activeElement) {
                            value = activeElement.dataset.value
                        }
                        break;
                    case 15:
                        activeElement = formElement.querySelector('textarea')
                        if(activeElement) {
                            value = activeElement.value
                        }
                        break;
                    case 16:
                        const fileUploads = getFileUploads()

                        let counter = 1

                        value = []
                        fileUploads.map(fileUpload => {

                            let file = {}
                            file.fileName = fileUpload
                            file.csrf = {}
                            file.csrf.name = ''
                            file.csrf.value = ''

                            value.push(file)
                        })
                        break;
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 240:
                    case 250:
                    case 260:
                        const format = new WKT();
                        const geom = getGeometryByLayerName(getDefaultName())
                        value = format.writeGeometry(new Point(geom))
                        break;
                    case 60:
                        value = formElement.querySelector('input').value + ' ' + formElement.querySelector('select').value
                        break;
                    case 29:
                    default:
                        value = formElement.querySelector('input').value
                        break;
                }

                attributeName = ''
                window.wizard.Items.map( wizardItem => {
                    const item = wizardItem.Items.find( item => item.AttributeID === parseInt(name))
                    if(item !== undefined) {
                        attributeName = item.Attribute
                    }
                })

                if(attributeName !== '') {
                    dataItem[attributeName] = value
                    dataItem[attributeName + '_old'] = ''
                }
            }
        })

        request.data.push(dataItem)

        if(window.wizard.settings.Recapthca !== null && window.wizard.settings.Recapthca !== "") {
            // Check for pulic key
            load(window.wizard.settings.Recapthca).then((recaptcha) => {
                recaptcha.execute('create').then((token) => {
                    request.token = token
                    postWfst('', request).then(() => {
                        processWfstRequest()
                        l.stop()
                    })
                })
            })
        } else {
            postWfst('', request).then(() => {
                processWfstRequest()
                l.stop()
            })
        }
    })
}
